import React from "react";
import { useAppDispatch, useAppSelector } from "src/store/store";
import Column from "@amzn/meridian/column";
import { ModelView, setSelectedModelId } from "src/store/modelManagementSlice";
import ModelViewList from "src/components/shared/titleAndButton/modelViewList";

const ModelRecords = () => {
  const dispatch = useAppDispatch();
  const { modelView } = useAppSelector((state) => state.modelSlice);

  return (
    <Column spacing={"300"}>
      {Object.values(modelView).map((view: ModelView) => (
        <ModelViewList
          modelView={view}
          onClick={() => {
            dispatch(setSelectedModelId(view.id));
          }}
        />
      ))}
    </Column>
  );
};

export default ModelRecords;
